import type { ReactNode } from 'react';

/**
 * Split `text` on case-insensitive occurrences of `term`, wrapping each match in
 * a <mark className="file-name-match"> for the file-browser search highlight.
 * Returns the raw string unchanged when there's no term, so non-search renders
 * are unaffected. Uses indexOf (not regex), so the term is matched literally.
 */
export function highlightMatch(text: string, term: string | undefined): ReactNode {
  if (!term) return text;
  const needle = term.toLowerCase();
  const haystack = text.toLowerCase();
  const parts: ReactNode[] = [];
  let from = 0;
  let key = 0;
  for (;;) {
    const at = haystack.indexOf(needle, from);
    if (at === -1) {
      parts.push(text.slice(from));
      break;
    }
    if (at > from) parts.push(text.slice(from, at));
    parts.push(
      <mark key={key++} className="file-name-match">
        {text.slice(at, at + needle.length)}
      </mark>
    );
    from = at + needle.length;
  }
  return parts;
}
